module.exports = __webpack_public_path__ + "media/A.ba6301ad.mp3";